{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "orgTypes": [
    {
      "id": "part-91-owner",
      "name": "Part 91 Owner-Operator",
      "segment": "operator"
    },
    {
      "id": "corporate-flight-dept",
      "name": "Corporate Flight Department",
      "segment": "operator"
    },
    {
      "id": "management-company",
      "name": "Aircraft Management Company",
      "segment": "operator"
    },
    {
      "id": "part-135",
      "name": "Part 135 Operator",
      "segment": "operator"
    },
    {
      "id": "fractional",
      "name": "Fractional / Multi-Base Operator",
      "segment": "operator"
    },
    {
      "id": "part-145",
      "name": "Part 145 Repair Station",
      "segment": "shop"
    },
    {
      "id": "independent-mro",
      "name": "Independent MRO",
      "segment": "shop"
    },
    {
      "id": "mobile-aog",
      "name": "Mobile & AOG Team",
      "segment": "shop"
    },
    {
      "id": "oem-service",
      "name": "OEM Service Center",
      "segment": "shop"
    },
    {
      "id": "component-shop",
      "name": "Component & Specialty Shop",
      "segment": "shop"
    },
    {
      "id": "operator-internal-mx",
      "name": "Operator with In-House Maintenance",
      "segment": "integrated"
    },
    {
      "id": "integrated-135-145",
      "name": "Integrated Operator + Repair Station",
      "segment": "integrated"
    }
  ]
}